"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var rich_text_types_1 = require("@contentful/rich-text-types");

var RichTextRenderer_1 = require("../RichTextRenderer/RichTextRenderer");

var accessors_1 = require("../../accessors");

var helpers_1 = require("../../util/helpers");

exports.FootnotesRichtextRenderer = function (_a) {
  var _b;

  var content = _a.content,
      WrapperElement = _a.wrapper,
      _c = _a.wrapperOptions,
      wrapperOptions = _c === void 0 ? {} : _c;

  if (helpers_1.isUndefined(content)) {
    return null;
  }

  var rendererOptions = (_b = {}, _b[rich_text_types_1.BLOCKS.PARAGRAPH] = function (node, children) {
    return react_1["default"].createElement(WrapperElement, __assign({}, wrapperOptions), children);
  }, _b[rich_text_types_1.INLINES.EMBEDDED_ENTRY] = function (node, children) {
    // TODO(benjamin): Make accessors aware of localized objects
    // or implement a different accessor
    var item = node.data.target;
    var elm = new accessors_1.ContentfulContentAccessor(item);
    var identifier = elm.text('identifier');
    return react_1["default"].createElement("sup", null, identifier['en-US']);
  }, _b);
  return react_1["default"].createElement(RichTextRenderer_1.ContentfulRichTextRenderer, {
    content: content,
    options: rendererOptions
  });
};